import { cn } from 'utils/cn.tsx';
import type { PolymorphicComponent } from 'utils/types';

interface Props {
	type?: 'info' | 'white' | 'warning' | 'primary' | 'dark-blue-transparent';
	className?: string;
}

export function Badge({
	as = 'div',
	children,
	type = 'info',
	className,
	...props
}: PolymorphicComponent<Props, 'div' | 'button' | 'a'>) {
	const Component = as || 'div';

	return (
		// @ts-expect-error todo: fix the types
		<Component
			class={cn(
				'text-xs font-medium rounded-full px-3 h-8 flex items-center justify-center',
				type === 'dark-blue-transparent' && 'bg-dark-blue-50 text-white',
				type === 'white' && 'bg-white text-dark-blue',
				type === 'info' && 'bg-light-gray text-dark-blue',
				type === 'warning' && 'bg-yellow text-dark-blue',
				type === 'primary' && 'bg-red text-white',
				className,
			)}
			{...props}
		>
			{children}
		</Component>
	);
}
